import { pattern } from './pattern';
export const passwordValidator = (value) => {
    const passwordRegex = new RegExp(pattern.password);
    if (passwordRegex.test(value)) {
        return { valid: true, error: false }
    } else { return { valid: false, error: 'Password must contain atleast 8 characters, atlest one Special Character, one Numeric and one Uppercase and one Lowercase Character' } }
}